import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../contexts/authContext';
import db from '../../services/query';
let pending;
function readAccess() {
  if (!pending) pending = db.getAll('mis-parity/capabilities').finally(() => { pending = null; });
  return pending;
}
function useAccessSummary() {
  const { accountProfile } = useContext(AuthContext) || {};
  const [access, setAccess] = useState({ permissions: [], sections: null, superuser: false, ready: false });
  useEffect(() => {
    let active = true;
    setAccess({ permissions: [], sections: null, superuser: false, ready: false });
    readAccess()
      .then(({ data }) => {
        if (!active) return;
        const summary = data.summary || { permissions: [], sections: null, superuser: false };
        setAccess({ ...summary, ready: true });
      })
      .catch(() => {
        if (active) setAccess((prev) => ({ ...prev, ready: true }));
      });
    return () => { active = false; };
  }, [accountProfile]);
  return access;
}
export function useAccessReady() {
  return useAccessSummary().ready;
}
export default function useParityAccess() {
  const access = useAccessSummary();
  return (...permissions) => access.superuser || permissions.some(p => (access.permissions || []).includes(p));
}
/** True when this role still has Aria2 path rows for the section. Missing data stays open. */
export function useSectionOpen() {
  const access = useAccessSummary();
  return (section) => {
    if (!section) return true;
    if (access.superuser) return true;
    if (!access.sections) return true;
    return access.sections[section] !== false;
  };
}
